import { AuthenticatedRouteGuard, LoginRequired, AccountGuard } from "auth";
import { PrintPreview as App } from "map-view";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import { ACCOUNT_USER_ROLE } from "~auth/types/__generated/gql/graphql";

const MapViewPage: NextPage = () => {
	return (
		<>
			<NextSeo
				title="Welcome to Mango GIS"
				description="Glad to have you onboard!"
			/>
			<LoginRequired>
				<AuthenticatedRouteGuard
					minimumAccessLevel={ACCOUNT_USER_ROLE.OWNER}
					onlyMapCreator
					hasMapEditAccess>
					<AccountGuard>
						<App />
					</AccountGuard>
				</AuthenticatedRouteGuard>
			</LoginRequired>
		</>
	);
};

export const getServerSideProps = () => {
	return {
		props: {},
	};
};

export default MapViewPage;
